import { UIColor, UITextView } from "uicore-ts"
import { CellView } from "../Custom components/CellView"
import { RHTables } from "../Custom components/RH/Utils_slop/RHDesignTokens"
import { RHEventLogViewTokens } from "../Custom components/RH/Utils_slop/RHViewTokens"


export function configureEventLogActionCell(cellView: CellView, text: string, hoverText: string) {

    cellView.configureWithObject({
        isAButton: true,
        hoverText: hoverText,
        titleLabel: {
            text: text,
            textColor: RHTables.rowTextColor,
            textAlignment: UITextView.textAlignment.left
        }
    })

    if (!cellView.buttonView) {
        return
    }

    cellView.buttonView.contentPadding = RHEventLogViewTokens.tableLinkContentPadding
    cellView.buttonView.colors.titleLabel = {
        normal: RHTables.rowTextColor,
        hovered: RHTables.rowActionTextColor,
        focused: RHTables.rowActionTextColor,
        highlighted: RHTables.rowActionTextColor,
        selected: RHTables.rowTextColor
    }
    cellView.buttonView.colors.background = {
        normal: UIColor.transparentColor,
        hovered: UIColor.transparentColor,
        highlighted: UIColor.transparentColor,
        selected: UIColor.transparentColor
    }
    cellView.buttonView.titleLabel.textAlignment = UITextView.textAlignment.left
    cellView.buttonView.updateContentForCurrentState()

}
